import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useProductData } from "../../context/ProductDataContext";
import { buildSpecificationRows } from "../../lib/productAttributes";

export default function SpecificationTable({ product, categoryId }) {
  const { categories, attributeConfig, attributeProfiles, schemaLabels } = useProductData();

  const rows = useMemo(
    () => buildSpecificationRows(
      product,
      categoryId || product?.categoryId,
      categories,
      attributeProfiles,
      attributeConfig,
      schemaLabels
    ),
    [product, categoryId, categories, attributeProfiles, attributeConfig, schemaLabels]
  );

  if (!rows.length) return null;

  let previousSection = null;
  return (
    <div className="mt-6 bg-white/90 backdrop-blur rounded-2xl border p-4">
      <h2 className="text-xl font-semibold mb-3">Specifikációk</h2>
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <table className="table-fixed w-full text-sm">
          <tbody>
            {rows.map((row, index) => {
              const showSection = row.sectionId !== previousSection;
              previousSection = row.sectionId;
              return (
                <React.Fragment key={row.id}>
                  {showSection && (
                    <tr className="bg-slate-50 border-t first:border-t-0">
                      <th colSpan={2} className="px-4 py-2 text-left text-xs uppercase tracking-wide text-slate-600">
                        {row.sectionLabel}
                      </th>
                    </tr>
                  )}
                  <tr className="border-t align-top">
                    <th className="w-[42%] px-4 py-3 text-left font-semibold text-slate-800 break-words">
                      {row.label}
                    </th>
                    <td className="px-4 py-3 text-slate-700 break-words">{row.value}</td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

SpecificationTable.propTypes = {
  product: PropTypes.object.isRequired,
  categoryId: PropTypes.string,
};
